import React from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "application/store";

import { MarkdownText } from "application/components";

import {
  Card,
  Title,
  Container,
  PendingText,
  HeaderStyled,
  QuestionText,
  IconContainer,
  AnswerDateText,
} from "./styles";
import { ChevronLeftIcon } from "application/assets";
import { ReactComponent as QuestionIcon } from "./assets/icon.svg";

const QuestionAnswer = () => {
  const navigate = useNavigate();
  const { deal } = useAppSelector((state) => state.deal);

  const answer = deal?.webinarRegistration?.answer;
  const question = deal?.webinarRegistration?.question;
  const answerDate = deal?.webinarRegistration?.answerDate;
  const date = moment(answerDate).format("MMMM DD, YYYY");

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Container>
      <HeaderStyled>
        <button type="button" onClick={goBack}>
          <IconContainer>
            <ChevronLeftIcon />
          </IconContainer>
          <span>Back</span>
        </button>
      </HeaderStyled>

      <Title>Your question & the answer</Title>

      <Card>
        <QuestionIcon />
        <QuestionText>{question}</QuestionText>
        <div className="divider" />
        {answer ? (
          <React.Fragment>
            <MarkdownText text={answer} />
            <AnswerDateText>{date}</AnswerDateText>
          </React.Fragment>
        ) : (
          <PendingText>Answer pending. You’ll be notified once it’s available.</PendingText>
        )}
      </Card>
    </Container>
  );
};

export default QuestionAnswer;
